import type { SVGProps } from 'react';
const SvgNdaContractDocumentStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M15.196 7.268V5.286L10.571.66H1.982A1.32 1.32 0 0 0 .661 1.982v14.536a1.32 1.32 0 0 0 1.321 1.321H8.59" />
      <path d="M17.179 9.91H10.57a.66.66 0 0 0-.66.661v1.768a5.8 5.8 0 0 0 3.964 5.5 5.8 5.8 0 0 0 3.964-5.5v-1.768a.66.66 0 0 0-.66-.66" />
      <path d="m12.223 13.545.991.99 2.313-2.312M3.964 5.286h6.607M3.964 9.25h3.304M3.964 13.214h3.304" />
    </g>
  </svg>
);
export default SvgNdaContractDocumentStreamlineCore;
